import React, { PropsWithChildren } from 'react';

import { isMediaId } from '~/common';
import { getBrightcoveMediaId } from '~/src/common/media';

import { extractDescription, extractDescriptionProps } from './content-utils';
import { InfoButton } from './InfoButton';
import { Content } from './types';
import { Autoplay } from '../Autoplay';
import { MediaPlayerBase } from '../MediaPlayerBase';

export const MediaHeroVideoPlayer: React.FC<
  PropsWithChildren<{
    content: Content;
  }>
> = ({ content, children }) => {
  const mediaId = getBrightcoveMediaId(content);
  if (!isMediaId(mediaId)) {
    return null;
  }
  const description = extractDescription(content);
  const descriptionProps = extractDescriptionProps(content);

  return (
    <MediaPlayerBase>
      <InfoButton description={description} props={descriptionProps} />
      <Autoplay />
      {children}
    </MediaPlayerBase>
  );
};
